'use client'

import React from 'react';
import {authApi} from "@/store/api/v1/auth";
import {VerifyEmailForm} from "@/components/Auth/VerifyEmailModal/VerifyEmailModal.styled";
import useFormSuccessMutation from "@/hooks/useFormSuccessMutation";
import {useRouter} from "@/helpers/navigation";

const VerifyEmailAction = ({children}) => {
    const router = useRouter()

    useFormSuccessMutation([authApi, 'verify'], () => {
        router.push('/business')
    }, [])

    return (
        <VerifyEmailForm api={authApi} endpoint={'verify'}>
            {children}
        </VerifyEmailForm>
    );
};

export default VerifyEmailAction;